<template>
  <!-- Google Tag Manager (noscript) -->
  <noscript v-if="GTM_ID">
    <iframe
      :src="`https://www.googletagmanager.com/ns.html?id=${GTM_ID}`"
      height="0"
      width="0"
      style="display: none; visibility: hidden"
    ></iframe>
  </noscript>
  <!-- End Google Tag Manager (noscript) -->
  <RouterView />
</template>

<script setup lang="ts">
import { useHead } from "@unhead/vue";
import { createStructuredData } from "@/utils/createStructuredData.ts";
import { useI18n } from "vue-i18n";

const GTM_ID: string | undefined = import.meta.env.VITE_GTM_ID;

const structuredData = createStructuredData(GTM_ID);
useHead(structuredData);

useHead({
  meta:
    import.meta.env.VITE_BUILD_ENV === "production"
      ? []
      : [
          {
            name: "robots",
            content: "noindex, follow",
          },
        ],
});

if (!import.meta.env.SSR) {
  const i18n = useI18n();

  const url = new URL(window.location.href);

  const lang = url.searchParams.get("lang");
  if (typeof lang === "string") {
    // Fallback to known supported langs
    const _lang = lang === "nl" ? "nl" : "en";

    i18n.locale.value = _lang;
    localStorage.setItem("preferredLocale", _lang);

    url.searchParams.delete("lang");
    window.history.replaceState({}, "", url.toString());
  }
}
</script>

<style scoped></style>
